import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { ArrowLeft } from "lucide-react";

const Header = ({ variant = "entry" }) => {
  const { lang, setLang, t } = useLanguage();
  const location = useLocation();
  const isInner = variant !== "entry";

  const toggleLang = (next) => setLang(next);

  // Smart back: from women/men go to /privat (gender stage); from business/others go to /
  const backTo = (variant === "women" || variant === "men") ? "/privat" : "/";

  const themeText = variant === "men" ? "text-white" : variant === "women" ? "text-[#2C332E]" : variant === "business" ? "text-[#1F2A24]" : "text-[#111]";
  const themeBorder = variant === "men" ? "border-[#2C313D]" : variant === "women" ? "border-[#D5CECA]" : variant === "business" ? "border-[#C8C2B6]" : "border-transparent";
  const accent = variant === "men" ? "#D4AF37" : variant === "women" ? "#738678" : variant === "business" ? "#5A7060" : "#111";
  // On dark theme: tint the logo lighter/gold so it stays visible
  const logoFilter = variant === "men"
    ? "brightness(0) saturate(100%) invert(78%) sepia(53%) saturate(458%) hue-rotate(2deg) brightness(95%) contrast(90%)"
    : "none";

  return (
    <header
      data-testid={`site-header-${variant}`}
      className={`relative w-full px-6 md:px-12 lg:px-20 py-6 flex items-center justify-center ${themeText} ${isInner ? "border-b " + themeBorder : ""}`}
    >
      {isInner && (
        <Link
          to={backTo}
          data-testid="nav-back-home"
          className="absolute left-6 md:left-12 lg:left-20 top-1/2 -translate-y-1/2 hidden md:inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] opacity-70 hover:opacity-100 transition"
        >
          <ArrowLeft size={14} />
          {t.nav.backHome}
        </Link>
      )}

      <Link
        to="/"
        data-testid="brand-logo-link"
        className="flex items-center justify-center"
      >
        <img
          src="/assets/green-horizon-logo-transparent.png"
          alt="Green Horizon Life — Self-Discovery Coaching"
          className="h-20 md:h-24 lg:h-28 w-auto"
          style={{ filter: logoFilter }}
        />
      </Link>

      <div
        data-testid="lang-switcher"
        className={`absolute right-6 md:right-12 lg:right-20 top-1/2 -translate-y-1/2 flex items-center text-xs uppercase tracking-[0.22em] border ${themeBorder} rounded-full overflow-hidden`}
      >
        <button
          data-testid="lang-de"
          onClick={() => toggleLang("de")}
          className={`px-3 py-1.5 transition ${lang === "de" ? "bg-current/10 font-semibold" : "opacity-60 hover:opacity-100"}`}
          style={lang === "de" ? { color: accent } : {}}
        >
          DE
        </button>
        <span className={`w-px self-stretch ${themeBorder.replace("border-", "bg-")}`} style={{ background: "currentColor", opacity: 0.2 }} />
        <button
          data-testid="lang-en"
          onClick={() => toggleLang("en")}
          className={`px-3 py-1.5 transition ${lang === "en" ? "font-semibold" : "opacity-60 hover:opacity-100"}`}
          style={lang === "en" ? { color: accent } : {}}
        >
          EN
        </button>
      </div>
    </header>
  );
};

export default Header;
